module.exports = __webpack_public_path__ + "img/picking-run.3293fe35.svg";